import { defineStore } from "pinia";

export const useSettingsStore = defineStore("settingsStore", {
  state: () => ({
    settings: {},
  }),

  getters: {
    getSettings(state) {
      return state.settings;
    },
  },

  actions: {
    restoreState() {
      try {
        const settingsStr = localStorage.getItem("settings");
        const settings = settingsStr ? JSON.parse(settingsStr) : null;
        if (settings) {
          this.settings = settings;
          console.log("Application settings are restored!");
        }
      } catch {}
    },
    setAppSetting(valueObject) {
      if (Object.prototype.hasOwnProperty.call(valueObject, "parent")) {
        this.settings[valueObject.parent] =
          this.settings[valueObject.parent] || {};
        this.settings[valueObject.parent][valueObject.key] = valueObject.value;
      } else {
        this.settings[valueObject.key] = valueObject.value;
      }
      // console.log("settings: ", this.settings);
      localStorage.setItem("settings", JSON.stringify(this.settings));
    },
  },
});
